module.exports = __webpack_public_path__ + "img/star-solid.9c09019b.svg";